export default __webpack_public_path__ + "static/media/t.min.9ebadef9.png";